export default __webpack_public_path__ + "static/media/camera.618153de.svg";